module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedLight.7937c59.woff2";